var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('LoginModal'),_c('AddAlertModal'),_c('AppHeader'),_c('div',{staticStyle:{"min-height":"60vh"}},[_c('router-view')],1),_c('AppFooter'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"go-to-top hidden-print",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-angle-up"})])
}]

export { render, staticRenderFns }